"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderApplicationStatusFields = exports.orderFaunaFields = exports.orderAllFields = exports.findOrderByIdFields = exports.findFaunaOrderByIdFields = exports.orderFlatFields = void 0;
exports.orderFlatFields = `
  applicationCaseNumber
  applicationUpdatedCaseNumber
  applicationTimestamp
  contractNote
  createdAt
  customerType
  deliveredAt
  expiresAt
  discount
  id
  isConcludedAtSeller
  financingType
  signedAt
  status
  timestamp
`;
exports.findFaunaOrderByIdFields = `
  ${exports.orderFlatFields}
  accessories {
    ...accessory
  }
  buyer {
    ...customer
  }
  chosenOffer {
    ...calculation
  }
  comments {
    ...comment
  }
  contracts {
    ...contract
  }
  customer {
    ...customer
  }
  insurance {
    ...insurance
  }
  lead {
    ...lead
  }
  margins {
    ...margin
  }
  offers {
    ...calculation
  }
  options {
    ...vehicleOption
  }
  orderReference {
    ...reference
  }
  pimSnapshot {
    ...pimSnapshot
  }
  reserveDetails {
    ...reserveDetails
  }
  tradeInVehicles {
    ...tradeIn
  }
  user {
    ...user
  }
`;
exports.findOrderByIdFields = `
  ${exports.findFaunaOrderByIdFields}
  config {
    ...vehicleConfiguration
  }
  events {
    ...orderEvent
  }
  vehicleOrderStatus {
    ...orderStatus
  }
`;
exports.orderAllFields = `
  ${exports.findOrderByIdFields}
  vehicles {
    ...vehicle
  }
`;
exports.orderFaunaFields = `
  ${exports.findFaunaOrderByIdFields}
  vehicles {
    ...vehicle
  }
`;
exports.orderApplicationStatusFields = `
  ${exports.orderFlatFields}
  application {
    ...application
  }
`;
//# sourceMappingURL=order.js.map